







import {Vue, Component} from 'vue-property-decorator';
import IconResetConvButton from '@/components/buttons/IconResetConvButton.vue';
import {AsixModule} from '@/store/modules/asix';
import {AppModule} from '@/store/modules/app';

@Component({
  components: {
    IconResetConvButton,
  },
})
export default class ChatResetConv extends Vue {
  public sending: boolean = false; // 追加

  public async reset(): Promise<void> { // 修正
    try {
      this.sending = true
      await AsixModule.resetConvPost()
    } catch (e) {
      AppModule.setIsMaintenance(true)
    } finally {
      this.sending = false
    }
  }
}
